import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import RulesApi from '@/api/rules'

@Component({})
export default class addTaskMixin extends Vue {
	public saving = false
	public companyId = ''
	public ruleId = ''

	public cancel() {
		this.$confirm({
			title: '提示',
			content: '返回将放弃本次编辑内容，请确定是否返回？',
			onOk: () => {
				this.$multiTab.closeCurrentPage()
			},
			onCancel() {},
		})
	}

	public async save(id?: string) {
		const ruleForm: any = this.$refs.ruleForm
		if (!ruleForm) {
			return
		}
		if (!this.companyId) {
			return
		}

		// const res = await ruleForm.getForm()
		ruleForm
			.getForm()
			.then((values: any) => {
				if (this.ruleId) {
					// 编辑规则保存时带规则id
					values.id = this.ruleId
				}
				values.companyId = this.companyId

				this.saving = true
				RulesApi.saveRule(values)
					.then((res: any) => {
						this.$multiTab.closeCurrentPage()
						// this.$multiTab.open('/Settings/Rules/RulesList')
						this.$message.success(`${this.ruleId ? '编辑' : '新增'}规则成功`)
					})
					.finally(() => {
						this.saving = false
					})
			})
			.catch((err: any) => {})
	}
}
